import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { MembershipGuard } from '@core/guards/membership.guard';
import { PlaylistGuard } from '@core/guards/playlist.guard';
import {
  LoginGuard,
  TokenCheckGuard,
  TokenValidGuard,
} from '@core/guards/token.guard';

import { MainLayoutComponent } from '@core/components/main-layout/main-layout.component';

const routes: Routes = [
  {
    path: 'membership',
    loadChildren: () =>
      import('./modules/membership/membership.module').then(
        (m) => m.MembershipModule
      ),
    canActivate: [],
  },
  {
    path: 'account',
    loadChildren: () =>
      import('./modules/account/account.module').then((m) => m.AccountModule),
    canActivateChild: [TokenValidGuard],
  },
  {
    path: 'aanmelden',
    loadChildren: () =>
      import('./modules/signup/signup.module').then((m) => m.SignupModule),
  },
  {
    path: 'wachtwoord-reset',
    loadChildren: () =>
      import('./modules/password-reset/password-reset.module').then(
        (m) => m.PasswordResetModule
      ),
    canActivate: [],
  },
  {
    path: 'inloggen',
    loadChildren: () =>
      import('./modules/login/login.module').then((m) => m.LoginModule),
    canActivate: [LoginGuard],
  },
  {
    path: 'acties',
    loadChildren: () => import('./modules/actions/actions.routes').then(m => m.actionRoutes),
  },
  {
    path: 'player/:video',
    loadChildren: () =>
      import('./modules/player/player.module').then((m) => m.PlayerModule),
    canActivate: [TokenCheckGuard, PlaylistGuard],
  },
  {
    path: '',
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./modules/home/home.module').then((m) => m.HomeModule),
        canActivate: [TokenCheckGuard, MembershipGuard],
      },
      {
        path: 'series',
        loadChildren: () =>
          import('./modules/series/series.module').then((m) => m.SeriesModule),
        canActivate: [TokenCheckGuard],
      },
      {
        path: 'videos',
        loadChildren: () =>
          import('./modules/movies/movies.module').then((m) => m.MoviesModule),
        canActivate: [TokenCheckGuard],
      },
      {
        path: 'artikelen',
        loadChildren: () =>
          import('./modules/articles/article.module').then(
            (m) => m.ArticleModule
          ),
        canActivate: [TokenCheckGuard],
      },
      {
        path: 'video/:slug',
        loadChildren: () =>
          import('./modules/video/video.module').then((m) => m.VideoModule),
        canActivate: [TokenCheckGuard],
      },
      {
        path: 'kortingscodes',
        loadChildren: () =>
          import('./modules/discounts/discounts.module').then(
            (m) => m.DiscountsModule
          ),
        canActivate: [TokenCheckGuard],
      },
      {
        path: 'zoeken/:value',
        loadChildren: () =>
          import('./modules/search/search.module').then((m) => m.SearchModule),
      },
      {
        path: 'vissers',
        loadChildren: () =>
          import('./modules/content-creators/content-creators.module').then(
            (m) => m.ContentCreatorsModule
          ),
        canActivate: [TokenCheckGuard],
      },
    ],
  },
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full',
  },
];

@NgModule({
	imports: [
		RouterModule.forRoot(routes, {
			useHash: false,
			scrollPositionRestoration: 'top',
			onSameUrlNavigation: 'reload',
			bindToComponentInputs: true
		})
	],
	exports: [RouterModule],
	providers: [
	]
})
export class AppRoutingModule { }
